<template>
  <div class="line-content" style="width: 100%" ref="line" :id="id">
    <div
      class="line-content--item flex_row"
      flex
      v-for="(item, idx) in optionsList"
      :key="idx"
    >
      <div
        flex
        v-for="(option, index) in item"
        :key="index"
        class="option-item"
        :name="index === 0 ? 'source' : 'target'"
        @click="
          clickOptions($event, option, idx, index === 0 ? 'left' : 'right')
        "
        :style="getOptionsStyle(index, option)"
        :class="{ isMobile: mobile }"
      >
        <div style="margin-right: 10px" class="questionSeq">
          {{ index === 0 ? uppercaseStr[idx] : lowercaseStr[idx] }}
        </div>
        <bc-view-common
          placeholder="点击编辑选项"
          :border="false"
          style="flex: 1; min-width: 0"
          :content="option.content"
          :fileInfo="option.fileInfo"
          :mobile="mobile"
          :isLineFile="mobile"
        ></bc-view-common>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { jsPlumb } from "jsplumb";
import XEUtils from "xe-utils";

const lowercaseStr = "abcdefghijklmnopqrstuvwxyz".split("");
const uppercaseStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const colors = [
  "rgba(240,63,36,0.55)",
  "rgba(92,34,35,0.42)",
  "rgba(240,124,130,0.7)",
  "rgba(122,115,116,0.76)",
  "rgba(238,184,195,0.8)",
  "rgba(99,7,28,0.62)",
  "rgba(126,22,113,0.56)",
  "rgba(46,49,124,0.68)",
  "#61649f",
  "#0f59a4",
  "#619ac3",
  "#c4cbcf",
  "#22a2c3",
  "#21373d",
  "#12a182",
  "#1a3b32",
  "#41ae3c",
  "#bec936",
  "#fed71a",
  "#ffa60f",
  "#4d4030",
  "#954416",
  "#363433",
  "#652b1c",
  "#ed3333",
];
export default {
  name: "bc-line-question-answer",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: Object,
      default: () => {},
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    typeOk: {
      type: String,
      default: "false",
    },
    isAnswerx: {
      type: Boolean,
      default: false,
    },
    isAnswertype: {
      type: String,
      default: "",
    },
  },
  watch: {
    options: {
      handler(val) {
        this.optionsList = val.map((i) => i.map((x) => ({ ...x })));
      },
      immediate: true,
    },
    optionsList: {
      handler(val) {
        let left = val.map((i) => i[0].title);
        let right = val.map((i) => i[1].title);
        this.left = left;
        this.right = right;
        // this.loadLine()
      },
      immediate: true,
      deep: true,
    },
    answer: {
      handler(val) {
        if (val.answerResults) {
          let str = val.answerResults.split(";");
          str.forEach((i) => {
            let [left, right] = i.split("");
            this.selectRight.push(right || "");
            this.selectLeft.push(left || "");
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      lowercaseStr,
      uppercaseStr,
      optionsList: [],
      instance: null,
      id: "",
      colors,
      clickLeft: "",
      clickRight: "",
      selectLeft: [],
      selectRight: [],
      left: [],
      right: [],
    };
  },
  created() {
    this.id = uuidv4() + "--line";
  },
  mounted() {
    // this.loadLine()
  },
  methods: {
    getOptionsStyle(index, option) {
      if (this.isAnswertype == "练习") {
        if (index === 0) {
          let colorIndex = this.colors[this.left.indexOf(option.title)];
          return {
            background: colors[this.left.indexOf(option.title)] + " !important",
          };
        } else {
          let colorIndex = this.left.indexOf(option.title.toLocaleUpperCase());
          return { background: colors[colorIndex] + " !important" };
        }
      }
      // if (this.isAnswertype != "练习") return;
      if (this.readonly) {
        if (this.answer.answerSituation === "1") {
          if (index === 0) {
            if (colors[this.selectLeft.indexOf(option.title)]) {
              return {
                background:
                  colors[this.selectLeft.indexOf(option.title)] + " !important",
                border: "1px solid #70B603",
              };
            } else {
              return { background: "#FBFBFB" };
            }
          } else {
            if (colors[this.selectRight.indexOf(option.title)]) {
              return {
                background:
                  colors[this.selectRight.indexOf(option.title)] +
                  " !important",
                border: "1px solid #70B603",
              };
            } else {
              return { background: "#FBFBFB" };
            }
          }
        } else {
          if (index === 0) {
            if (colors[this.selectLeft.indexOf(option.title)]) {
              return {
                background:
                  colors[this.selectLeft.indexOf(option.title)] + " !important",
                border: "1px solid #D9001B",
              };
            } else {
              return { background: "#FBFBFB", border: "1px solid #D9001B" };
            }
          } else {
            if (colors[this.selectRight.indexOf(option.title)]) {
              return {
                background:
                  colors[this.selectRight.indexOf(option.title)] +
                  " !important",
                border: "1px solid #D9001B",
              };
            } else {
              return { background: "#FBFBFB", border: "1px solid #D9001B" };
            }
          }
        }
      } else {
        if (index === 0) {
          if (colors[this.selectLeft.indexOf(option.title)]) {
            return {
              background:
                colors[this.selectLeft.indexOf(option.title)] + " !important",
            };
          } else {
            return { background: "#FBFBFB" };
          }
        } else {
          if (colors[this.selectRight.indexOf(option.title)]) {
            return {
              background:
                colors[this.selectRight.indexOf(option.title)] + " !important",
            };
          } else {
            return { background: "#FBFBFB" };
          }
        }
      }
    },
    clickOptions(event, options, idx, type) {
      if (this.typeOk == "false") {
        if (this.isAnswerx) return;
      }
      if (this.readonly) return;
      if (type === "left") {
        this.clickLeft = options.title;
        let haveIndex = this.selectLeft.findIndex((i) => i === options.title);
        if (haveIndex > -1) {
          this.$set(this.selectLeft, haveIndex, "");
          this.$set(this.selectRight, haveIndex, "");
        } else {
          let emptyIndex = this.selectLeft.findIndex((i) => i === "");
          if (emptyIndex > -1) {
            this.$set(this.selectLeft, emptyIndex, options.title);
          } else {
            this.selectLeft.push(options.title);
          }
        }
      } else {
        this.clickRight = options.title;
        let haveIndex = this.selectRight.findIndex((i) => i === options.title);
        if (haveIndex > -1) {
          this.$set(this.selectLeft, haveIndex, "");
          this.$set(this.selectRight, haveIndex, "");
        } else {
          let emptyIndex = this.selectRight.findIndex((i) => i === "");
          if (emptyIndex > -1) {
            this.$set(this.selectRight, emptyIndex, options.title);
          } else {
            this.selectRight.push(options.title);
          }
        }
      }

      let obj = {};
      let str = "";

      this.selectLeft.forEach((i, index) => {
        let iTitle = this.optionsList.find((o) => o[0].title === i);

        if (iTitle && iTitle.length) {
          let right = this.selectRight[index];
          let iValue = "";
          if (right) {
            let title = this.optionsList.find((o) => o[1].title === right);
            iValue = title ? title[1].title : "";
          }
          obj[iTitle[0].title] = iValue;
        }
      });
      str = Object.keys(obj)
        .map((key) => `${key}${obj[key]}`)
        .join(";");
      this.$emit("change", str);
    },
  },
};
</script>

<style scoped lang="scss">
.line-content {
  width: 100%;
  position: relative;

  .line-content--item {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    ::v-deep .stem-content {
      height: 100%;
    }
  }

  & + .line-content {
    margin-top: 10px;
  }

  //.line-content--item + .line-content--item {
  //  margin-left: 100px;
  //}
}

//.line-content--item + .line-content--item {
//}
.option-item + .option-item {
  //margin-top: 10px;
}

.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item {
  flex: 1;
  min-width: 0;
  width: 400px;
}

.option-item + .option-item {
  margin-left: 100px;
}

.option-item.isMobile + .option-item.isMobile {
  margin-left: 50px;
}

.option-item {
  margin-bottom: 10px;
  background: #fbfbfb;
  border-radius: 6px;
  padding-left: 16px;
  border: 1px solid #fbfbfb;
  .questionSeq {
    padding: 8px 0;
  }
  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
    }
    .text-break-all {
      p {
        img {
          max-width: 100px;
          max-height: 100px;
        }
      }
    }
  }
}
.flex_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>
